// src/UserFormPage.js

import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Layout,
  Avatar,
  Upload,
  Switch,
  Row,
  Col,
  Breadcrumb,
  Card,
  message,
} from "antd";
import { ArrowLeftOutlined, EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import BreadcrumbList from "../../../../Shared/Components/Breadcrumb/Breadcrumb";
import { ServiceUtils } from "../../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../../Shared/Utils/ToasterUtils";
import CryptoJS from "crypto-js";
import { getDecryptSession } from "../../../../Shared/Utils/CommonUtils";
const { Option } = Select;
const { Header, Content } = Layout;





const AddEditUser = ({ ...props }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { userId } = useParams();
  console.log(userId,"user id on add")
  const [userDetails, setUserDetails] = useState({});
  const [loader, setLoader] = useState(true);
  const [defaultUserData, setDefaultUserData] =useState();
  const [userData, setUserData] = useState();
  const [roles, setRoles] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [passwordEnabled, setPasswordEnabled] = useState(false);
  const [departmentsList, setDepartmentsList] = useState([]);
  const [subDepartmentsList,setSubDepartmentsList] = useState([]);

  useEffect(() => {
    fetchDepartments();
    // getUserRoles();
    if (userId) {
    }
  }, []);

  const getUserRoles = () => {
    let payload={
      type : "roles"
    }
    ServiceUtils.postRequest('lookup', payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          const rolesList = response?.data?.data;
          setRoles(rolesList);
        } 
        else if(response.status === 401 ){
          navigate('/logout');
        }
        else {
          alertService.error(response.data.message)
        }
      },
      (error) => {
        alertService.error('Error while fetching data')
        console.log(error)
      }
    );
  }

  const fetchDepartments = () => {
      ServiceUtils.getRequest("listDepartments").then(
        (response) => {
          if (response.status === 200 && response?.data.status) {
            let departmentIds = JSON.parse(JSON.stringify(response?.data?.data));
            setDepartmentsList(departmentIds);
          } else if (response.status === 401) {
            navigate("/logout");
          } else {
            alertService.error(response.data.message);
          }
        },
        (error) => {
          alertService.error("Error while fetching data");
          console.log(error);
        }
      );
    };
  
    const fetchSubDepartments = () => {
      let payload = {
        departments: form.getFieldValue('department')
      };
      ServiceUtils.postRequest("listSubDepartments", payload).then(
        (response) => {
          if (response.status === 200 && response?.data.status) {
            let subDeptIds = JSON.parse(JSON.stringify(response?.data?.data));
            setSubDepartmentsList(subDeptIds);
          } else if (response.status === 401) {
            navigate("/logout");
          } else {
            alertService.error(response.data.message);
          }
        },
        (error) => {
          alertService.error("Error while fetching data");
          console.log(error);
        }
      );
    };

  const getUserDetails = () => {
    let data = {
      key: "9",
      firstName: "Murali",
      lastName:"Pinnaka",
      email: "m.pinnaka",
      role: "Admin",
      passwordEnabledLogin: false,
      id: 9,
    }
    setUserData(data)
    // setLoader(false);
  }

  useEffect(()=>{
    const session = localStorage.getItem("arcutis-user");
    const userDetails = getDecryptSession(session);
    setUserDetails(userDetails);
    if(userId){
      getUserdata()
    }
    else{
      setLoader(false);
      // setLoader(false);
    }
  },[])

  const SubmitButton = ({ form, children }) => {
    const [submittable, setSubmittable] = useState(false);

    const values = Form.useWatch([], form);
    useEffect(() => {
      form
        .validateFields({
          validateOnly: true,
        })
        .then(() => setSubmittable(true))
        .catch(() => setSubmittable(false));
    }, [form, values]);
    return (
      <Button type="primary" htmlType="submit" disabled={!submittable || (JSON.stringify(defaultUserData)===JSON.stringify(values)) } onClick={handleSave}>
        {children}
      </Button>
    );
  };

  const getUserdata = () => {
    let payload={
      userId : Number(userId)
    }
    ServiceUtils.postRequest('userData', payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let userDa = JSON.parse(JSON.stringify(response.data.data));
          setDefaultUserData(userDa);
          const deptIds = response?.data?.data?.department;
          const subDeptIds = response?.data?.data?.subDepartment;
          form.setFieldsValue({
            email: response?.data?.data?.email,
            firstName: response?.data?.data?.firstName,
            lastName: response?.data?.data?.lastName,
            department: deptIds,
            subDepartment: [],
          });

          if (deptIds?.length > 0) {
            ServiceUtils.postRequest("listSubDepartments", {
              departments: deptIds,
            }).then((res) => {
              if (res.status === 200 && res?.data.status) {
                const subDeptOptions = res?.data?.data;
                setSubDepartmentsList(subDeptOptions);

                // set subDepartments that are part of the default data
                const selectedSubDept = subDeptOptions
                  .filter((dept) => subDeptIds.includes(dept.value))
                  .map((id) => id.value);
                form.setFieldsValue({
                  subDepartment: selectedSubDept,
                });
              }
            });
          }
          setLoader(false);
        } 
        else if(response.status === 401 ){
          navigate('/logout');
        }
        else {
          alertService.error(response.data.message)
        }
      },
      (error) => {
        alertService.error('Error while fetching data')
        console.log(error)
      }
    );
  }

  const addEditUser = () => {
    let userInfo = form.getFieldsValue(true);;
    if(userInfo?.password){
      const key = 'ThisIsASecureKey1234567890123456'; // Same key as used in the backend
      const iv = 'ThisIsAnIV123456'; // Same IV as used in the backend
      let pass = userInfo?.password;
      const cipherText = CryptoJS.AES.encrypt(pass, CryptoJS.enc.Utf8.parse(key), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
      });
      userInfo.password = cipherText.toString();
    }
    if(userInfo?.email){
      userInfo.email = userInfo.email + "@arcutis.com"; 
    }
    let payload = 
    {
      "userData" : userInfo,
      "type" : userId ? "edit" : "add",
      "userId": userId
    }
    ServiceUtils.postRequest('userOps', payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          navigate("/admin/settings")
        } 
        else if(response.status === 401 ){
          navigate('/logout');
        }
        else {
          alertService.error(response.data.message)
        }
      },
      (error) => {
        alertService.error('Error while fetching data')
        console.log(error)
      }
    );
  }

  const handleSave = (values) => {
    addEditUser()
  };

  const handleInputChange = (key, value, action) => {
    if(key==="password"){
      // console.log(key)
      if(value){
        // console.log(value)
        setIsRequired(true)
      }
      else{
          // console.log(value)
          setIsRequired(false);
      }
    } else if (key === 'department') {
      fetchSubDepartments();
    }
    if (action === "onchange") {
      setUserData({
        ...userData,
        [key]: value,
      });
    }
  };

  const getPasswordStatus = () => {
    return userData?.["passwordEnabledLogin"] ? true : false;
  }

  const [isRequired, setIsRequired] = useState(false);

  const checkRequired = () => {
    return isRequired;
  }



  return (
    <div>
      {!loader && (
        <div>
          <Card
            style={{ width: "100%", height: "fit-content" }}
            bodyStyle={{ padding: "10px" }}
          >
            {userId ? (
              <Breadcrumb
                separator=""
                items={[
                  {
                    title: (
                      <>
                        <div
                          className="settings-breadcrumb"
                          onClick={() => navigate("/admin/settings")}
                        >
                          <div>
                            <ArrowLeftOutlined className="arrow-display" />
                            <span style={{ marginLeft: "2px" }}>Settings</span>
                          </div>
                        </div>
                      </>
                    ),
                  },
                  {
                    type: "separator",
                  },
                  {
                    title: (
                      <div style={{ display: "flex" }}>
                        <div style={{ margin: "0px 2px" }}>Edit User</div>
                      </div>
                    ),
                  },
                ]}
              />
            ) : (
              <Breadcrumb
                separator=""
                items={[
                  {
                    title: (
                      <>
                        <div
                          className="settings-breadcrumb"
                          onClick={() => navigate("/admin/settings")}
                        >
                          <div>
                            <ArrowLeftOutlined className="arrow-display" />
                            <span style={{ marginLeft: "2px" }}>Settings</span>
                          </div>
                        </div>
                      </>
                    ),
                  },
                  {
                    type: "separator",
                  },
                  {
                    title: (
                      <div style={{ display: "flex" }}>
                        <div style={{ margin: "0px 2px" }}>Add User</div>
                      </div>
                    ),
                  },
                ]}
              />
            )}
          </Card>
          <Content
            style={{
              padding: "24px",
              background: "#fff",
              height: "calc(100vh - 90px)",
            }}
          >
            <Form
              // initialValues={userData && userData}
              form={form}
              name="validateOnly"
              layout="vertical"
              autoComplete="off"
            >
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col
                  className="gutter-row"
                  xs={{ flex: "100%" }}
                  sm={{ flex: "100%" }}
                  md={{ flex: "50%" }}
                  lg={{ flex: "25%" }}
                  xl={{ flex: "25%" }}
                >
                  <label
                    class="form-label text-ellipsis-one-line"
                    style={{ marginBottom: "5px" }}
                  >
                    First name
                  </label>
                  <Form.Item
                    name="firstName"
                    rules={[
                      {
                        required: true,
                        message: "First name is required.",
                      },
                    ]}
                  >
                    <Input
                      onChange={(e) =>
                        handleInputChange(
                          "firstName",
                          e.target.value,
                          "onchange"
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col
                  className="gutter-row"
                  xs={{ flex: "100%" }}
                  sm={{ flex: "100%" }}
                  md={{ flex: "50%" }}
                  lg={{ flex: "25%" }}
                  xl={{ flex: "25%" }}
                >
                  <label
                    class="form-label text-ellipsis-one-line"
                    style={{ marginBottom: "5px" }}
                  >
                    Last name
                  </label>
                  <Form.Item
                    name="lastName"
                    rules={[
                      {
                        required: true,
                        message: "Last name is required.",
                      },
                    ]}
                  >
                    <Input
                      onChange={(e) =>
                        handleInputChange(
                          "lastName",
                          e.target.value,
                          "onchange"
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col
                  className="gutter-row"
                  xs={{ flex: "100%" }}
                  sm={{ flex: "100%" }}
                  md={{ flex: "50%" }}
                  lg={{ flex: "25%" }}
                  xl={{ flex: "25%" }}
                >
                  <label
                    class="form-label text-ellipsis-one-line"
                    style={{ marginBottom: "5px" }}
                  >
                    Email
                  </label>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        pattern: new RegExp(/^[a-zA-Z0-9]*$/),
                        message: "No Space or Special Characters Allowed",
                      },
                      {
                        required: true,
                        message: "Email is required.",
                      },
                    ]}
                  >
                    <Input
                      addonAfter="@arcutis.com"
                      onChange={(e) =>
                        handleInputChange("email", e.target.value, "onchange")
                      }
                    />
                  </Form.Item>
                </Col>
                {/* <Col
                    className="gutter-row"
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "25%" }}
                    xl={{ flex: "25%" }}
                  >
                    <label
                      class="form-label text-ellipsis-one-line"
                      style={{ marginBottom: "5px" }}
                    >
                      Role
                    </label>
                    <Form.Item name="role"
                      rules={
                        [
                          {
                            required: true,
                            message: "Role is required.",
                          },
                        ]
                      }
                      >
                      <Select
                        mode="multiple"
                        showSearch
                        onChange={(e) => {
                          handleInputChange("role", e, "onchange");
                        }}
                        options={roles}
                        allowClear
                        filterOption={(input, option) =>
                          option.label.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  </Col> */}
                <Col
                  className="gutter-row"
                  xs={{ flex: "100%" }}
                  sm={{ flex: "100%" }}
                  md={{ flex: "50%" }}
                  lg={{ flex: "25%" }}
                  xl={{ flex: "25%" }}
                >
                  <label
                    class="form-label text-ellipsis-one-line"
                    style={{ marginBottom: "5px" }}
                  >
                    Department
                  </label>
                  <Form.Item
                    name="department"
                    rules={[
                      {
                        required: false,
                        message: "Department is required.",
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      showSearch
                      onChange={(e) => {
                        handleInputChange("department", e, "onchange");
                      }}
                      onClear={() => {
                        handleInputChange("department", [], "onchange");
                      }}
                      options={departmentsList}
                      allowClear
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
                <Col
                  className="gutter-row"
                  xs={{ flex: "100%" }}
                  sm={{ flex: "100%" }}
                  md={{ flex: "50%" }}
                  lg={{ flex: "25%" }}
                  xl={{ flex: "25%" }}
                >
                  <label
                    class="form-label text-ellipsis-one-line"
                    style={{ marginBottom: "5px" }}
                  >
                    Sub Department
                  </label>
                  <Form.Item
                    name="subDepartment"
                    rules={[
                      {
                        required: false,
                        message: "Sub Department is required.",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      mode="multiple"
                      onChange={(e) => {
                        handleInputChange("subDepartment", e, "onchange");
                      }}
                      onClear={() => {
                        handleInputChange("subDepartment", [], "onchange");
                      }}
                      options={subDepartmentsList}
                      allowClear
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
                {!userId && (
                  <>
                    <Col
                      className="gutter-row"
                      xs={{ flex: "100%" }}
                      sm={{ flex: "100%" }}
                      md={{ flex: "50%" }}
                      lg={{ flex: "25%" }}
                      xl={{ flex: "25%" }}
                    >
                      <label
                        class="form-label text-ellipsis-one-line"
                        style={{ marginBottom: "5px" }}
                      >
                        Enable SSO Login
                      </label>
                      <Form.Item name="enabledSSOLogin">
                        <Switch
                          onChange={(e) => {
                            handleInputChange(
                              "enabledSSOLogin",
                              e,
                              "onchange"
                            );
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      className="gutter-row"
                      xs={{ flex: "100%" }}
                      sm={{ flex: "100%" }}
                      md={{ flex: "50%" }}
                      lg={{ flex: "25%" }}
                      xl={{ flex: "25%" }}
                    >
                      <label
                        class="form-label text-ellipsis-one-line"
                        style={{ marginBottom: "5px" }}
                      >
                        Enable Password Login
                      </label>
                      <Form.Item name="passwordEnabledLogin">
                        <Switch
                          onChange={(e) => {
                            handleInputChange(
                              "passwordEnabledLogin",
                              e,
                              "onchange"
                            );
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}
                {/* userData?.["passwordEnabledLogin"] */}
                {form.getFieldValue("passwordEnabledLogin") && !userId && (
                  <Col
                    className="gutter-row"
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "25%" }}
                    xl={{ flex: "25%" }}
                  >
                    <label
                      class="form-label text-ellipsis-one-line"
                      style={{ marginBottom: "5px" }}
                    >
                      Password
                    </label>
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Password is required.",
                        },
                      ]}
                    >
                      <Input.Password
                        iconRender={(visible) =>
                          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                        }
                        disabled={!userData?.passwordEnabledLogin}
                        onChange={(e) =>
                          handleInputChange(
                            "password",
                            e.target.value,
                            "onchange"
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
            </Form>
            <div
              className="submit-block"
              style={{ position: "absolute", bottom: "5px", right: "5px" }}
            >
              <div style={{ paddingRight: "10px" }}>
                <SubmitButton form={form}>
                  {userId ? "Update" : "Save"}
                </SubmitButton>
              </div>
              <Button onClick={() => navigate("/admin/settings")}>
                Cancel
              </Button>
            </div>
          </Content>
        </div>
      )}
    </div>
  );
};

export default AddEditUser;
